module.exports = __webpack_public_path__ + "static/media/2023-SWG-Uni-Student-Comp-Banner-1980x1080px.bb7d9ecb.jpg";